import { Divider } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useTranslation, WithTranslation } from 'react-i18next'
import { Redirect, withRouter } from 'react-router'
import { InjectedFormProps } from 'redux-form'
import Flex from 'typescript-styled-flex'
import logoBedBooking from '../../assets/bb-logo-big.png'
import {
  Form,
  FormGroup,
  PasswordInput,
  SquareCheckbox,
} from '../../components/FormBuilder'
import { is } from '../../components/MediaQuery'
import Button from '../../components/Template/Button'
import Card from '../../components/Template/Card'
import { IIsAuthorized } from '../../routes/withProtected/Protected'
import { ButtonLabel } from '../../components/Template/Premium'
import styled, { ITheme } from '../../theme'
import { getApiUrlForEnv } from '../../utils/ApiUrl'
import Error from '../../assets/icons/error.svg'
import { Mixpanel } from '../../utils/Mixpanel'

const Wrapper = styled.div`
  width: 100%;
  padding: 0px 19px 19px 19px;
`

export const ErrorLabel = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 20px;
  color: #ffffff;
  text-decoration: none solid rgb(255, 255, 255);
  text-align: center;
  margin-top: 23px;
  font-weight: 500;
`

export const ErrorMessage = styled.div`
  width: 520px;
  height: 290px;
  border-radius: 10px;
  background-color: rgb(242 148 148 / 50%);
  stroke-width: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #fc0000;
  @media (max-width: ${(props: ITheme) => props.theme.breakpoints.mobile}) {
    width: 100%;
  }
`

function PasswordResetToken({
  handleSubmit,
  submitting,
  isAuthorized,
  ...rest
}: InjectedFormProps & IIsAuthorized & WithTranslation & any) {
  const [valid, setValid] = useState(true)
  const [loading, setLoading] = useState(true)
  const [email, setEmail] = useState('')
  const isDesktop = is.desktop()
  const { t } = useTranslation()

  const params = new URLSearchParams(rest.location.search)

  const buildUrl = url => {
    const EnvUrl = getApiUrlForEnv()
    return process.env.NODE_ENV === 'production' ? `${EnvUrl}${'/'}${url}` : url
  }

  useEffect(() => {
    if (params.get('first')) {
      Mixpanel.track('Employee List New Employee Create Password Page View', {
        'Employee ID': params.get('employee'),
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    fetch(buildUrl(`/api/v2/user/token/token/${rest.match.params.token}`))
      .then(res => {
        if (res.status !== 200) {
          setValid(false)
        } else {
          res.json().then(data => {
            setEmail(data.items.email)
            setValid(true)
            setLoading(false)
          })
        }
      })
      .catch(() => {
        setValid(false)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [rest.match.params.token])

  const checkLabel = () => {
    return (
      <span>
        {t('terms_and_conditions_text_1')}{' '}
        <a
          onClick={e => {
            e.stopPropagation()
          }}
          target={'_blank'}
          rel="noopener noreferrer"
          style={{ color: '#00a541' }}
          href={t('BED_3621_terms_of_service_link')}
        >
          {t('terms_and_conditions_text_2')}
        </a>{', '}
        <a
          onClick={e => {
            e.stopPropagation()
          }}
          target={'_blank'}
          rel="noopener noreferrer"
          style={{ color: '#00a541' }}
          href={t('BED_3621_privacy_policy_link')}
        >
          {t('terms_and_conditions_text_4')}
        </a>{' '}{t('terms_and_conditions_text_3')}{' '}
        <a
          onClick={e => {
            e.stopPropagation()
          }}
          target={'_blank'}
          rel="noopener noreferrer"
          style={{ color: '#00a541' }}
          href={t('BED_22412_baner_cookie_policy_link')}
        >
          {t('BED_22487_bed_booking_cookie_policy_2')}
        </a>
      </span>
    )
  }

  if (isAuthorized) {
    return <Redirect to={'/'} />
  }

  const handleSubmitError = e => {
    rest.change('token', rest.match.params.token)
    rest.change('first', params.get('first'))
    rest.change('employee', params.get('employee'))
    rest.change('email', email)
    rest.clearAsyncError('password')
    rest.clearAsyncError('rpassword')
    e.preventDefault()

    setTimeout(() => {
      handleSubmit(e)
    }, 500)
  }

  return (
    <div>
      <Flex
        full={true}
        center={true}
        style={{ paddingTop: '50px', paddingBottom: '50px' }}
      >
        <Card
          style={valid ? {} : { maxWidth: 'unset', width: 'unset' }}
          withBackgroundColor={'#FFF'}
          withShadow={true}
        >
          <Flex center={true} style={{ padding: '10px 0px 20px' }}>
            <img
              style={{ width: '350px' }}
              alt={'BedBooking'}
              src={logoBedBooking}
            />
          </Flex>
          {loading ? (
            <></>
          ) : !valid ? (
            <>
              <Wrapper>
                <ErrorMessage>
                  <img
                    alt={'error-icon'}
                    src={Error}
                    width={71}
                    height={63}
                  ></img>
                  <ErrorLabel>
                    {t(
                      params.get('employee')
                        ? 'BED_3688_link_not_exist'
                        : 'OUT_4234_link_not_exist',
                    )}
                  </ErrorLabel>
                  <ErrorLabel>
                    {t(
                      params.get('employee')
                        ? 'BED_3688_mail_create_password_link_not_active_page'
                        : 'OUT_4234_generate_new_link_message',
                    )}
                  </ErrorLabel>
                </ErrorMessage>
                {!params.get('employee') && (
                  <Button
                    href={'/reset'}
                    primary={true}
                    style={{
                      height: '45px',
                      marginTop: '20px',
                      minHeight: '45px',
                      width: isDesktop ? '520px' : '100%',
                    }}
                  >
                    {t('OUT_4234_forgot_password_button')}
                  </Button>
                )}
              </Wrapper>
            </>
          ) : (
            <>
              <Divider />
              <Flex style={{ padding: '20px' }} full={true}>
                <Form onSubmit={handleSubmitError} style={{ height: '100%' }}>
                  <FormGroup.Nested column={true}>
                    <PasswordInput.ReduxField
                      name={'password'}
                      autocomplete={'current-password'}
                      placeholder={t('OUT_4234_new_password_8_characters')}
                      width={'100%'}
                      style={{
                        height: '42px',
                        maxHeight: '42px',
                        minHeight: '42px',
                      }}
                      wrapperStyle={{
                        height: '42px',
                        maxHeight: '42px',
                        minHeight: '42px',
                      }}
                    />
                    <PasswordInput.ReduxField
                      name={'rpassword'}
                      autocomplete={'current-password'}
                      placeholder={t('OUT_4234_repeat_password_8_characters')}
                      width={'100%'}
                      style={{
                        height: '42px',
                        maxHeight: '42px',
                        minHeight: '42px',
                      }}
                      wrapperStyle={{
                        height: '42px',
                        maxHeight: '42px',
                        minHeight: '42px',
                      }}
                    />
                  </FormGroup.Nested>
                  <Button
                    as={'button'}
                    disabled={submitting}
                    type={'submit'}
                    primary={true}
                    style={{
                      height: '45px',
                      marginTop: '20px',
                      minHeight: '45px',
                    }}
                  >
                    <ButtonLabel style={{ color: 'white', fontSize: '1em' }}>
                      {t(params.get('first') === '1'? 'save':'OUT_4234_change_password_button')}
                    </ButtonLabel>
                  </Button>
                </Form>
              </Flex>
              <Flex
                row={isDesktop}
                column={!isDesktop}
                full={true}
                justifyBetween={true}
                style={{
                  borderTop: '1px solid #ddd',
                  padding: '20px 20px',
                  height: isDesktop ? '78px' : '123px',
                }}
              >
                {params.get('first') === '1' && (
                  <SquareCheckbox.ReduxField
                    fireEventOnClick={true}
                    name={'agreement'}
                    label={checkLabel()}
                    noSpacing={true}
                    isHorizontal={true}
                    isReverse={true}
                    wrapperStyle={{
                      maxWidth: 'unset',
                      zIndex: 0,
                    }}
                  />
                )}
              </Flex>
            </>
          )}
        </Card>
      </Flex>
    </div>
  )
}

export default withRouter(PasswordResetToken)
